/* eslint-disable no-unused-vars */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useRef, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardHeader, Modal,
  Button, InputGroup, Progress, ProgressBar,
} from 'reactstrap';
// import moment from 'moment';
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import TVInductionForm from '../../components/TVs/TVInductionForm';
import PodProgressBar from '../../components/TVs/PodProgressBar';

import { get } from '../../helpers/api_helper';
// import { Can } from '../../utilities/Can';

function TVInduction(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const { t } = props;

  const TOTAL_TVS = 225;

  document.title = t('TV Induction');

  const sjnRef = useRef(null);

  const [sjn, setSjn] = useState(null);
  const [inductions, setInductions] = useState([]);
  const [expectedTVs, setExpectedTVs] = useState(0);

  useEffect(() => {
    const fetchInductions = async () => {
      try {
        const response = await get('/api/tvs/stats');

        setInductions(response);
      } catch (error) {
        toastr.error(t('Error fetching inductions'));
      }
    };

    if (sjn === null) {
      // calculate expected TVs based on time of day
      // Step 1: Create time range boundaries
      const now = new Date();

      const start = new Date();
      start.setHours(6, 0, 0, 0); // 6:00 AM

      const end = new Date();
      end.setHours(16, 30, 0, 0); // 4:30 PM

      // Step 2: Calculate total time in seconds
      const totalSeconds = (end - start) / 1000;

      // Step 3: Calculate elapsed time since start
      const elapsedSeconds = Math.max(0, (now - start) / 1000); // clamp at 0 if before 6am

      // Step 4: Calculate expected number of TVs processed
      setExpectedTVs(Math.min(
        TOTAL_TVS,
        Math.floor((elapsedSeconds / totalSeconds) * TOTAL_TVS),
      ));
    }

    if (sjn === null) {
      sjnRef.current.focus();
    }

    fetchInductions();
  }, [sjn]);

  return (
    <div className="page-content">
      <div className="container-fluid">
        {sjn === null && (
          <Row className="mt-4">
            <Col sm="4" />
            <Col sm="4">
              <Card>
                <CardBody className="p-4">
                  <Row>
                    <Col sm="2" />
                    <Col sm="8">
                      <InputGroup>
                        <input
                          ref={sjnRef}
                          type="text"
                          placeholder={t('Scan or type SJN')}
                          style={{ textTransform: 'uppercase' }}
                          className="form-control input-lg bg-secondary bg-soft"
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              setSjn(sjnRef.current.value.replace(/^X/, '').toUpperCase());
                            }
                          }}
                        />
                        <Button color="primary" size="lg" className="ml-2" onClick={() => { setSjn(sjnRef.current.value.toUpperCase()); }}>{t('Search')}</Button>
                      </InputGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {inductions.length < expectedTVs && (
                <PodProgressBar goal={TOTAL_TVS} expected={expectedTVs} progress={inductions.length} label={`${inductions.length}/${TOTAL_TVS} TVs done - ${expectedTVs} to stay on track.`} />
              )}
              {inductions.length >= expectedTVs && (
                <PodProgressBar goal={TOTAL_TVS} expected={expectedTVs} progress={inductions.length} label={`${inductions.length}/${TOTAL_TVS} TVs done - ON TRACK!`} />
              )}
            </Col>
          </Row>
        )}

        {sjn !== null && (
          <TVInductionForm
            sjn={sjn}
            onSuccess={() => { setSjn(null); }}
            onCancel={() => { setSjn(null); }}
          />
        )}
      </div>
    </div>
  );
}

TVInduction.defaultProps = {
  t: (x) => (x),
};

TVInduction.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(TVInduction));
